<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates2">
<p class="centerImage"><img alt="images" id="plate2" src="images/plate2.jpg"/></p>
<p class="caption">Learning to fly, Anstey, May 1939. Back row (left to right): Ellison, Williams, Bridge, Cotterell, Lewis, Gosling, Parsons, Farmer. Middle: Lake, Petterson, Fenton, Barwis, Worrall, RWF, Kerry, Phillips. Front: Thorogood, Dennison, Hampton, Rees, Tripe, McLean, Wright, Siddons, Smith, Proven.</p>
<p class="caption">(Don Lake flew with 219 Squadron, but was killed in a flying accident with FIU in September, 1941. Laurence Thorogood flew with 87 Squadron in the Battle and at the end of the war had the DFC. Don Smith flew with 616 Squadron but was killed in action on 27 September 1940. Claude Parsons flew with 610 and 66 Squadrons in the Battle, but was lost on a sweep over France in 1941.)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates2.vue?31c8d09d